import axios from 'axios';
import { API_URL } from '../config/api';
import SessionService from './SessionService';

export interface GroupListDto {
  id: number;
  sectorId: number;
  name: string;
  photoUrl?: string | null;
  participantCount: number;
  whatsAppGroupId: string;
  createdAt: string;
  updatedAt: string;
  lastViewedAt?: string | null;
  unreadCount: number;
  isViewed: boolean;
  lastMessage?: string | null;
  lastMessageTime?: string | null;
}

export interface GroupMessageDto {
  id: number;
  grupoId: number;
  senderName: string;
  senderJid?: string | null;
  content?: string | null;
  type: string;
  url?: string | null;
  fileName?: string | null;
  mimeType?: string | null;
  sentAt: string;
  sentByUs: boolean;
  whatsAppMessageId?: string | null;
  replyToMessageId?: string | null;
  reacaoContato?: string | null;
  reacaoOperador?: string | null;
  isForwarded?: boolean;
}

export const getGroupsBySector = async (sectorId: number): Promise<GroupListDto[]> => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Token de autenticação não encontrado');
  const { data } = await axios.get<GroupListDto[]>(`${API_URL}/Group/sector/${sectorId}`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return Array.isArray(data) ? data : (data as any)?.data ?? [];
};

export const getGroupById = async (id: number): Promise<GroupListDto | null> => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Token de autenticação não encontrado');
  const { data } = await axios.get<GroupListDto>(`${API_URL}/Group/${id}`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return data ?? null;
};

export const getGroupMessages = async (groupId: number, limit = 100): Promise<GroupMessageDto[]> => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Token de autenticação não encontrado');
  const { data } = await axios.get<GroupMessageDto[]>(`${API_URL}/Group/${groupId}/messages`, {
    params: { limit },
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return Array.isArray(data) ? data : (data as any)?.data ?? [];
};

export const markGroupAsViewed = async (groupId: number): Promise<void> => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Token de autenticação não encontrado');
  await axios.post(
    `${API_URL}/Group/${groupId}/viewed`,
    {},
    { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
  );
};

/** Exclui o grupo apenas no Ligchat (não sai do grupo no WhatsApp). */
export const deleteGroupFromLigchat = async (groupId: number): Promise<void> => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Token de autenticação não encontrado');
  await axios.delete(`${API_URL}/Group/${groupId}`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
};
